import ModalWithoutBottom from "./ModalWithoutBottom";
export default ModalWithoutBottom;
